import React, { useEffect, useState } from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";
import { ALL_ROUTES_ARRAY, PDRL_ADMIN_ROUTES_COMPONENTS, PDRL_FINANCE_COMPONENTS, PDRL_MARKETING_COMPONENTS, PDRL_SALES_COMPONENTS, PDRL_SUCCESS_ENGI_COMPONENTS, PDRL_TELE_Caller_COMPONENTS, PDRL_TELECALLER_SALES_COMPONENTS } from "./routes";
import NavBar from "./Components/NavBar";
import Login from "./features/Login/components/Login";        
import ResetPassword from "./features/ResetPassword/ResetPassword";
import ProtectedRoute from "./ReusableComponents/ProtectedRoute";
import Profile from "./features/Profile/Profile";
import ProSidebar from "./Components/ProSidebar";
import { ErrorBoundary } from "react-error-boundary"
import { useSelector } from "react-redux";
import NotFounds from "./ReusableComponents/NotFounds";
import { BHUMEET_TEAM_ROLES } from "./appConstants";
import Authentication from "./Authentication";
import Popup from "./ReusableFunctions/Popup";
import DspOnboardingForm from "./Components/DspSignup/DspOnboardingForm";
import SignUp from "./features/SignUp/components/Signup";
import { useSignUpContext } from "./context/SignUpContext";

const App = () => {
  const user = useSelector(state => state.user?.user)
  const { signUpDetails } = useSignUpContext();
  const [routes, setRoutes] = useState([])

  
      const [isOnline, setIsOnline] = useState(navigator.onLine);
  
  
  
      useEffect(()=>{
          
          if(!isOnline){
              return Popup.alert("ERROR","Please Turn ON your Network or Change your Network","ERROR")
          }else{
              const button = document.querySelector("#ErrorContinue");
              if (button) {
                  button.click();
              }
          }
      },[isOnline])

      useEffect(()=>{
        const updateNetworkStatus = () => {
          setIsOnline(navigator.onLine);
          };
  
          // Add event listeners for network status changes
          window.addEventListener("online", updateNetworkStatus);
          window.addEventListener("offline", updateNetworkStatus);
  
          // Cleanup event listeners on component unmount
          return () => {
          window.removeEventListener("online", updateNetworkStatus);
          window.removeEventListener("offline", updateNetworkStatus);
          };
      },[])

  useEffect(() => {
    if (user) {
      let ROUTES = []
      switch (user.bhumeet_role) {
        case BHUMEET_TEAM_ROLES.ADMIN.NAME:
          ROUTES = PDRL_ADMIN_ROUTES_COMPONENTS
          break;

        case BHUMEET_TEAM_ROLES.CUSTOMER_SUPPORT_ENGINEER.NAME:
          ROUTES = PDRL_SUCCESS_ENGI_COMPONENTS
          break;

        case BHUMEET_TEAM_ROLES.FINANCE.NAME:
          ROUTES = PDRL_FINANCE_COMPONENTS
          break;
        
        case BHUMEET_TEAM_ROLES.MARKETING.NAME:
          ROUTES = PDRL_MARKETING_COMPONENTS
          break;

            
        case BHUMEET_TEAM_ROLES.SALES.NAME:
          ROUTES = PDRL_SALES_COMPONENTS
          break;

        case BHUMEET_TEAM_ROLES.TELECALLER.NAME:
          // console.log(PDRL_TELE_Caller_COMPONENTS)
          ROUTES = PDRL_TELE_Caller_COMPONENTS
          break;
          case BHUMEET_TEAM_ROLES.TELECALLER_SALES.NAME:
            // console.log(PDRL_TELE_Caller_COMPONENTS)
            ROUTES = PDRL_TELECALLER_SALES_COMPONENTS
            break;
        // case BHUMEET_TEAM_ROLES.TELECALLER_SALES.NAME:
        //   ROUTES = PDRL_TELE_Caller_COMPONENTS
        //   break;
        default:
          ROUTES = ALL_ROUTES_ARRAY;
          break;
      }
      // console.log(ROUTES)
      setRoutes(ROUTES)
    }
    else if (!window.location.pathname.includes('login')) window.location.href = ("/login")

  }, [user])

  return (
    <Router>
      <div style={{ display: "flex", height: "100vh" }}>
        <ProSidebar />
        <Authentication/>
        <div className="main-app-wrapper" style={{ transition: "width 0.8 ease-in" }}>
          {(user && !signUpDetails.redirectLogin) && <NavBar />}
          <Routes>
            <Route path="/resetPassword" element={<ResetPassword />} />
            <Route path="/login" element={<Login />} />
            <Route path="/onboarding/form" element={<DspOnboardingForm />} />
            <Route path="/signup" element={<SignUp />} />
            <Route path="/notFound" element={<NotFounds msg={"Page not found 404"} hideBtn />} />

            {
              // user && !user?.bhumeet_role && user?.dsp?.is_verified &&
              routes.map((route, key) => (
                <Route key={key} path={route.path} element={
                  <ErrorBoundary>
                    <ProtectedRoute>{route.element}</ProtectedRoute>
                  </ErrorBoundary>
                }
                />
              ))
            }
            {/* 
            {
              // user && user?.bhumeet_role == BHUMEET_TEAM_ROLES.ADMIN.NAME &&
              PDRL_ADMIN_ROUTES_COMPONENTS.map((route, key) => (
                <Route key={key} path={route.path} element={
                  <ErrorBoundary>
                    <ProtectedRoute type={"Admin"} >{route.element}</ProtectedRoute>
                  </ErrorBoundary>
                } />
              ))
            } */}

            {
              user && user?.bhumeet_role == BHUMEET_TEAM_ROLES.ADMIN.NAME &&
              <Route path="/profile" element={
                <ProtectedRoute type="Admin" >
                  <Profile />
                </ProtectedRoute>}
              />
            }

            {/* {
              // user && user?.bhumeet_role == BHUMEET_TEAM_ROLES.FINANCE.NAME &&
              PDRL_FINANCE_COMPONENTS.map((route, key) => (
                <Route key={key} path={route.path} element={
                  <ErrorBoundary>
                    <ProtectedRoute type={"Finance"} >{route.element}</ProtectedRoute>
                  </ErrorBoundary>
                } />
              ))
            } */}

            {
              user && !user?.bhumeet_role &&
              <Route path="/profile" element={
                <ProtectedRoute >
                  <Profile />
                </ProtectedRoute>}
              />
            }
            {
              user && user?.bhumeet_role == BHUMEET_TEAM_ROLES.FINANCE.NAME &&
              <Route path="/profile" element={
                <ProtectedRoute type="Finance" >
                  <Profile />
                </ProtectedRoute>}
              />
            }

            {/* {
              // user && user?.bhumeet_role == BHUMEET_TEAM_ROLES.CUSTOMER_SUPPORT_ENGINEER.NAME &&
              PDRL_SUCCESS_ENGI_COMPONENTS.map((route, key) => (
                <Route key={key} path={route.path} element={
                  <ErrorBoundary>
                    <ProtectedRoute type={"Customer support engineer"} >{route.element}</ProtectedRoute>
                  </ErrorBoundary>
                } />
              ))
            } */}

            {
              user && user?.bhumeet_role == BHUMEET_TEAM_ROLES.CUSTOMER_SUPPORT_ENGINEER.NAME &&
              <Route path="/profile" element={<ProtectedRoute type="Customer support engineer">
                <Profile />
              </ProtectedRoute>} />
            }

            {
              user && user?.bhumeet_role == BHUMEET_TEAM_ROLES.SALES.NAME &&
              <Route path="/profile" element={<ProtectedRoute type="Sales">
                <Profile />
              </ProtectedRoute>} />
            }
             {
              user && user?.bhumeet_role == BHUMEET_TEAM_ROLES.MARKETING.NAME &&
              <Route path="/profile" element={<ProtectedRoute type={BHUMEET_TEAM_ROLES.MARKETING.NAME}>
                <Profile />
              </ProtectedRoute>} />
            }
            

            {user && <Route path="*" element={<NotFounds msg={"Page not found 404"} hideBtn />} />}
          </Routes>
        </div>
      </div>
    </Router>
  );
};

export default App;